export const setTotalByMonth = (category: string, totalByMonth: any) => ({
    type: 'SET_TOTAL_BY_MONTH',
    payload: { category, totalByMonth }
});
